import { Form } from 'formik'
import styled from 'styled-components'
import { Icon } from '@mdi/react'

import theme from 'theme_'
import { BodyPrimary, Font12, Font14 } from 'components/Typography'
import CommonButton from 'components/Button/CommonButton'
import { CommonLinkButton } from 'components/Button'
import { EventsFormBottomSizes } from '../../styles'

export const HomeServicesEventsTitle = styled(BodyPrimary)`
  padding-bottom: 24px;
`
export const HomeServicesEventsFormContainer = styled(Form)`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
`

export const HomeServicesEventsFormCloseBtn = styled.button`
  position: absolute;
  padding: 0;
  background-color: transparent;
  border: 0;
  outline: none;
  display: flex;
  align-self: flex-end;
  cursor: pointer;
  @media ${theme.devices.tablet} {
    display: none;
  }
`

export const HomeServicesEventsFormTopContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: min-content;
  padding: 24px;
  position: relative;
`

export const HomeServicesEventsFormBottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  @media ${theme.devices.tablet} {
    max-height: ${EventsFormBottomSizes.tablet};
  }
  @media ${theme.devices.tabletLandscape} {
    max-height: ${EventsFormBottomSizes.tabletLandscape};
  }
`

export const HomeServicesEventsDropdownsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`

export const HomeServicesEventsFormInfo = styled(BodyPrimary)`
  color: ${theme.colors.darkeyGrey};
  margin-bottom: 16px;
`

export const HomeServicesEventsFormButtons = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  @media ${theme.devices.tablet} {
    justify-content: center;
    flex-wrap: wrap;
  }
  @media ${theme.devices.tabletLandscape} {
    justify-content: space-between;
    flex-wrap: nowrap;
  }
`

export const HomeServicesEventsResetButtonMobileLabel = styled.div`
  display: block;
  @media ${theme.devices.tablet} {
    display: none;
  }
`

export const HomeServicesEventsResetButtonDesktopLabel = styled.div`
  display: none;
  @media ${theme.devices.tablet} {
    display: block;
  }
`

export const HomeServicesEventsResetButton = styled(CommonButton)`
  background: transparent;
  order: 1;
  width: calc(50% - 5px);
  @media ${theme.devices.tablet} {
    order: 2;
    width: 100%;
  }
  @media ${theme.devices.tabletLandscape} {
    order: 1;
    width: calc(50% - 5px);
  }
`

export const HomeServicesEventsSubmitButton = styled(CommonButton)`
  width: 100%;
`

export const HomeServicesEventsSubmitButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease;
  width: calc(50% - 5px);
  order: 2;
  @media ${theme.devices.tablet} {
    order: 1;
    width: 100%;
  }
  @media ${theme.devices.tabletLandscape} {
    order: 2;
    width: calc(50% - 5px);
  }
`

export const HomeServicesEventsSubmitSuccessWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  transition: all 0.2s ease;
  min-height: 42px;
`

export const HomeServicesEventsSubmitSuccess = styled(BodyPrimary)`
  font-weight: 900;
  color: ${theme.colors.otterWarmBlack};
`

export const HomeServicesEventsIcon = styled(Icon)`
  color: ${theme.colors.successGreen};
  margin-right: 8px;
`

export const HomeServicesEventsArgumentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const HomeServicesEventsArgumentsHeader = styled.div`
  ${Font12};
  color: ${theme.colors.darkeyGrey};
  margin-bottom: 8px;
`

export const HomeServicesEventsArgumentsInputsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${theme.spacing.xs};
  flex-direction: row;
  @media ${theme.devices.tablet} {
    flex-direction: column;
  }
  @media ${theme.devices.tabletLandscape} {
    flex-direction: row;
  }
  input {
    margin: 0;
  }
`

export const HomeServicesEventsArgumentsBody = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  margin-bottom: 12px;
  @media ${theme.devices.tablet} {
    margin-bottom: 24px;
  }
  @media ${theme.devices.tabletLandscape} {
    margin-bottom: 12px;
  }
`

export const DeleteArgumentButton = styled(CommonLinkButton)`
  padding: 4px 0 0;
`

export const AddArgumentButton = styled(CommonLinkButton)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
`

export const HomeServicesIcon = styled(Icon)`
  color: ${theme.colors.horizonOrange};
`

export const HomeServicesHr = styled.hr`
  border: none;
  border-bottom: 1px solid ${theme.colors.lightGrey};
  margin: 12px 0 24px 0;
`

export const HomeServicesEventsDropdownWrapper = styled.div`
  .select__dropdown-indicator {
    color: ${theme.colors.darkeyGrey};
  }

  .select__menu {
    position: absolute;
    ${Font14};
    background: ${theme.colors.white};
    box-shadow: 0 4px 40px ${theme.colors.commonShadow};
    border-radius: 8px;
    .select__menu-list {
      max-height: 270px;
    }
  }

  .select__control--is-focused {
    border: none;
    box-shadow: none;
  }

  .select__control {
    background: ${theme.colors.white};
    border: none;
    box-shadow: inset 0 0 0 0.5px ${theme.colors.pelicanGrey};
    border-radius: 8px;
    display: flex;
    transition: all 0.3s ease;
    font-weight: normal;
    ${Font14};
    width: 100%;

    :focus-within {
      box-shadow: inset 0 0 0 1px ${theme.colors.horizonOrange};
    }
  }
`

export const HomeServicesMissingAccess = styled.div`
  display: flex;
  flex-flow: row;
  gap: 16px;
  align-items: center;
`
